import React, { useEffect } from "react";
import moment from "moment";
import { Controller } from "react-hook-form";
import AsyncSelect from "react-select/lib/Async";
import { useDebouncedAsyncSelect } from "../../../../../Utils/Hooks/useDebounce";
import { CreacionTrasladoAlmacenApi } from "../api/CreacionTrasladoAlmacenApi";

export const DatosAlmacen = ({
    datosAlmacen,
    formControl,
    formErrors,
    almacenSeleccionado,
}) => {
    const { getAlmacenesVaciado } = CreacionTrasladoAlmacenApi();

    const materiaPrimaId =
        datosAlmacen && datosAlmacen.materia_prima
            ? datosAlmacen.materia_prima.id
            : undefined;

    const almacenOrigenId = datosAlmacen ? datosAlmacen.id : undefined;

    const loadAlmacenesVaciado = useDebouncedAsyncSelect(function (search) {
        if (!materiaPrimaId || !almacenOrigenId) {
            return Promise.resolve([]); // no consulta
        }

        const params = {
            search: search,
            materia_id: materiaPrimaId,
            excluir_bodega_id: almacenOrigenId,
        }

        if (datosAlmacen && datosAlmacen.acopio) {
            params.acopio_id = datosAlmacen.acopio.id
        }

        return getAlmacenesVaciado(params);
    });

    return (
        <div className="mb-1">
            {datosAlmacen && (
                <React.Fragment>
                    <div className="formulario-fields-row">
                        <div className="formulario-field">
                            <label className="text-center">
                                Almacén de origen
                            </label>
                            <span className="text-center">
                                {datosAlmacen.nombre}
                            </span>
                        </div>
                        <div className="formulario-field">
                            <label className="text-center">Materia prima</label>
                            <span className="text-center">
                                {datosAlmacen.materia_prima
                                    ? datosAlmacen.materia_prima.nombre
                                    : ""}
                            </span>
                        </div>
                        <div className="formulario-field">
                            <label className="text-center">Acopio</label>
                            <span className="text-center">
                                {datosAlmacen.acopio
                                    ? datosAlmacen.acopio.nombre
                                    : "Planta ERSA"} {/* SE ASUME QUE ES LA PLANTA DE ERSA */}
                            </span>
                        </div>
                        <div className="formulario-field">
                            <label className="text-center">
                                Almacén destino
                            </label>
                            {almacenSeleccionado ? (
                                <span className="text-center">
                                    {almacenSeleccionado.nombre}
                                </span>
                            ) : (
                                <React.Fragment>
                                    <Controller
                                        name="almacen_destino"
                                        control={formControl}
                                        rules={{
                                            required:
                                                "Debe seleccionar un almacén destino",
                                        }}
                                        render={({ field }) => (
                                            <AsyncSelect
                                                {...field}
                                                key={materiaPrimaId || "empty"}
                                                className="react-select-container"
                                                isSearchable
                                                isClearable
                                                defaultOptions={
                                                    !!materiaPrimaId
                                                }
                                                loadOptions={
                                                    loadAlmacenesVaciado
                                                }
                                                getOptionValue={(option) =>
                                                    option.id
                                                }
                                                getOptionLabel={(option) =>
                                                    option.nombre
                                                }
                                                onChange={(selected) => {
                                                    field.onChange(selected);
                                                }}
                                            />
                                        )}
                                    />
                                    {formErrors.almacen_destino && (
                                        <small className="text-danger">
                                            {formErrors.almacen_destino.message}
                                        </small>
                                    )}
                                </React.Fragment>
                            )}
                        </div>
                    </div>
                </React.Fragment>
            )}
        </div>
    );
};
